class Converters {
  static blgToGravity(blg: number): number {
    return (blg / (258.6 - ((blg / 258.2) * 227.1))) + 1;
  }

  static gravityToPlato(sg: number): number {
    return (-1 * 616.868) + (1111.14 * sg) - (630.272 * Math.pow(sg, 2)) + (135.997 * Math.pow(sg, 3));
  }

  static srmToEbc(srm: number): number {
    return srm * 1.97;
  }

  static ebcToSrm(ebc: number): number {
    return ebc / 1.97;
  }
}

export default Converters;
